import React from 'react';
import PropTypes from 'prop-types';
import "./ApplicationScanResult.scss";
import { handleKeyDown } from '../../Utility/ApplicationFormUtility';
import Close from '../SVG/Close';
import { MAIN_CONFIG } from '../../../config/main';
import fileDownload from 'js-file-download';
import axios from 'axios';
import Download from '../SVG/Download';
import TagManager from 'react-gtm-module';

const ApplicationScanResult = ({ handleClose = () => { }, name = '', scanUrl = '', eventLabel }) => {

    const fileURL = scanUrl
    const fileName = scanUrl.split('/')[6]

    const handleDownload = (url, filename) => {
        axios.get(url, {
            responseType: 'blob',
        })
            .then((res) => {
                fileDownload(res.data, filename);
            })
            .catch((error) => {
                console.log(error);
            });
    }


    const viewDownloadReport = async (e, document_url, file_name) => {
        e.preventDefault();

        const dataLayerEvent = {
            event: 'Download_AI_Plagiarism_Report',
            event_category: 'AI_Plagiarism_Scan',
            event_label: eventLabel,
            value: new Date().toISOString()
        };

        // Push data to Google Tag Manager's data layer
        TagManager.dataLayer({
            dataLayer: dataLayerEvent
        });

        handleDownload(document_url, file_name);
    };

    return (
        <div className="sycn-result-page">
            <div className="sycn-result-page__header">
                <div>
                    <h1 className='H1DesktopGreen sycn-result-title'>Scan Result</h1>
                </div>
                <div>
                    <button onKeyDown={(e) => handleKeyDown(e, () => handleClose())} aria-label='Close Modal' className="event-head H6DesktopGrey close-btn" onClick={handleClose}><Close color={MAIN_CONFIG.COLORS.fillGreen} ariaLabel="Close Modal Button" ariaLabelDescription='' tabIndex={-1} /></button>
                </div>
            </div>
            <div className='title-download-container'>
                <div className='sycn-result-sub-title H6DesktopGray'>{name}</div>
                <button onClick={(e) => viewDownloadReport(e, fileURL, fileName)}>
                    <Download width={15} height={15} color={MAIN_CONFIG.COLORS.fillGreen} className="download-icon" />
                    Download
                </button>
            </div>

            <iframe src={`${scanUrl}#toolbar=0&navpanes=0&scrollbar=0`} title="scan result" style={{ width: "100%", height: "71vh", zIndex: 1 }} />
        </div>
    )
}

ApplicationScanResult.propTypes = {
    name: PropTypes.string,
    scanUrl: PropTypes.string,
    eventLabel: PropTypes.string,
    handleClose: PropTypes.func,
};

export default ApplicationScanResult;
